// @ts-nocheck
import Connect from './connect';
export default new Connect();
